import { IEnv } from './env.type';

export class EnvConfig {
  constructor() {}

  get env(): IEnv {
    // Support both browser (window.ENV) and Node.js (process.env) environments
    const env = typeof window !== 'undefined' ? window.ENV : (process.env as unknown as IEnv);
    if (env === undefined) throw new Error(`Env not found`);
    return env;
  }

  public getEnvKey(key: keyof IEnv) {
    const env = this.env[key];

    if (env === undefined) throw new Error(`Env variable ${key} not found`);
    return castValue(env as string);
  }
}

const castValue = (value: string): boolean | number | string => {
  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase();
    if (lowerValue === 'true') {
      return true;
    } else if (lowerValue === 'false') {
      return false;
    }
  }

  // Check if the value is a valid number
  if (!isNaN(Number(value)) && !isNaN(parseFloat(value))) {
    return Number(value);
  }

  // For all other cases, return the value as is (string)
  return value;
};

// Feature flags are read through this: getEnvKey throws when a deployment's
// env.js predates the key, and a missing flag should hide the feature, not
// break the app. Anything other than an explicit "true" stays off.
export function isEnvFeatureEnabled(key: keyof IEnv): boolean {
  try {
    return envConfig.getEnvKey(key) === true;
  } catch {
    return false;
  }
}

const envConfig = new EnvConfig();
export default envConfig;
